import React, { Component } from "react"
import loader from "@albelli/photoselector/lib/ImagePicker/Graphic/loader.svg"
import { PhotoOrganiserItem } from "../Components/CategoryItemContainer"

export interface RequestState {
  items: PhotoOrganiserItem[]
  totalItemsCount: number
  title: string
  monthsWithPhotos?: any[]
  yearsWithPhotos?: any[]
  loading: boolean
}

interface ResponseData {
  items: PhotoOrganiserItem[]
  totalItemsCount: number
}

// - A higher order component (HOC) that fetches images and passes them as a prop to a page
// - Official docs: https://reactjs.org/docs/higher-order-components.html
const withRequest = (WrappedComponent: any) => {
  return class Request extends Component<any, RequestState> {
    sortingDirection = ""
    sortingField = ""
    selectedMonth = 0
    selectedYear = 0
    didUnMount = false

    constructor(props: any) {
      super(props)

      this.state = {
        items: [],
        totalItemsCount: 0,
        title: "",
        monthsWithPhotos: [],
        yearsWithPhotos: [],
        loading: true
      }

      this.sortingDirection = props.sortingDirection || "Ascending"
      this.sortingField = props.sortingField || "CollectionCreateDate"
    }

    setSelectedMonth(selectedMonth: number) {
      this.selectedMonth = selectedMonth
    }

    setSelectedYear(selectedYear: number) {
      this.selectedYear = selectedYear
    }

    getSimilars(id: string, removeSimilarIconCallback: () => void) {
      return this.props.getSimilars(id).then((res: ResponseData) => {
        removeSimilarIconCallback()
        res.items.forEach((item) => (item.similarCount = 0))
        this.setState({
          totalItemsCount: this.state.totalItemsCount + res.totalItemsCount - 1,
          items: this.state.items.flatMap((item) => (item.id === id ? res.items : item))
        })
        return
      })
    }

    getItems({ skip = this.state.items.length, emptyList = false }) {
      if (this.state.totalItemsCount === skip || this.didUnMount) return

      const params = {
        Skip: skip,
        SortingDirection: this.sortingDirection,
        SortingField: this.sortingField,
        SelectedMonth: this.selectedMonth,
        SelectedYear: this.selectedYear
      }

      return this.props.request(params).then((res: any) => {
        this.setState({
          ...res,
          items: emptyList ? res.items : this.state.items.concat(res.items)
        })
        return res.items
      })
    }

    handleSortingChange(sortingDirection: string, sortingField: string) {
      const { totalItemsCount, items } = this.state
      this.sortingDirection = sortingDirection
      if ((totalItemsCount === items.length && this.sortingField === sortingField) || (totalItemsCount === items.length && sortingField === "")) {
        return this.setState({
          items: items.slice().reverse()
        })
      }

      this.sortingField = sortingField
      this.getItems({ skip: 0, emptyList: true })
    }

    componentDidMount() {
      const params = {
        Skip: 0,
        SortingDirection: this.sortingDirection,
        SortingField: this.sortingField,
        SelectedMonth: this.selectedMonth,
        SelectedYear: this.selectedYear
      }

      this.props
        .request(params)
        .then((res: any) => this.setState(res))
        .catch((e: any) => console.error("Unable to retrieve PhotoOrginiser photos.", e))
    }

    componentWillUnmount() {
      this.didUnMount = true
    }

    render() {
      if (this.state.loading)
        return (
          <span className="photoselector-loader">
            <img src={loader} />
          </span>
        )
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          sortingDirection={this.sortingDirection}
          sortingField={this.sortingField}
          selectedMonth={this.selectedMonth}
          setSelectedMonth={this.setSelectedMonth.bind(this)}
          setSelectedYear={this.setSelectedYear.bind(this)}
          getItems={this.getItems.bind(this)}
          getSimilarsPhotos={this.getSimilars.bind(this)}
          handleSortingChange={this.handleSortingChange.bind(this)}
        />
      )
    }
  }
}

export default withRequest
